import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';

// Auth
import { useAuth } from '../auth/AuthContext';

// Components
import SpinnerFullUI from '../components/shared/Spinner/SpinnerFullUI';
import PrivateRoute from '../components/shared/PrivateRoute/PrivateRoute';
import PublicRoute from '../components/shared/PublicRoute/PublicRoute';

const Login = React.lazy(() => import('../components/Login/Login'));
const ForgotPassword = React.lazy(() =>
  import('../components/ForgotPassword/ForgotPassword'),
);
const Page404 = React.lazy(() => import('../components/404/404'));
const Talents = React.lazy(() => import('../components/Talents/Talents'));
const TalentLists = React.lazy(() =>
  import('../components/TalentLists/TalentLists'),
);
const Talent = React.lazy(() => import('../components/Talent/Talent'));
const TalentJob = React.lazy(() => import('../components/TalentJob'));
const Jobs = React.lazy(() => import('../components/Jobs'));
const JobPage = React.lazy(() => import('../components/Job'));
const Console = React.lazy(() => import('../components/Console/Console'));
const CancelAppointment = React.lazy(() =>
  import('../components/CancelAppointment/CancelAppointment'),
);
// const SimilarJobs = React.lazy(() => import('../components/SimlarJobs'));
const NASjobs = React.lazy(() => import('../components/NASjobs'));
const NAScampaigns = React.lazy(() => import('../components/NAScampaigns'));
// const Meta = React.lazy(() => import('../components/Meta'));
// const JobMatches = React.lazy(() => import('../components/JobMatches'));
// const ProfilmatcherAlerts = React.lazy(() =>
//   import('../components/ProfilmatcherAlerts'),
// );
// const JobImports = React.lazy(() => import('../components/JobImports'));

const PrivateRoot = () => {
  const { isLoadingUser } = useAuth();

  return (
    <>
      {isLoadingUser ? (
        <SpinnerFullUI />
      ) : (
        <Suspense fallback={<SpinnerFullUI />}>
          <Switch>
            <PrivateRoute path="/" exact component={Talents} />
            <PrivateRoute
              path="/candidates-lists"
              exact
              component={TalentLists}
            />
            <PrivateRoute path="/candidates/:id" exact component={Talent} />
            <PrivateRoute
              path="/candidates/:candidateId/jobs/:jobId"
              exact
              component={TalentJob}
            />
            <PrivateRoute path="/jobs" exact component={Jobs} />
            {/* <PrivateRoute path="/jobs/imports" exact component={JobImports} /> */}
            <PrivateRoute path="/jobs/:id" exact component={JobPage} />
            <PrivateRoute path="/console" exact component={Console} />
            <PrivateRoute
              path="/cancel-appointment/:id/:accountName"
              exact
              component={CancelAppointment}
            />
            {/* <PrivateRoute path="/similar-jobs" exact component={SimilarJobs} /> */}
            <PrivateRoute path="/nas-dashboard" exact component={NASjobs} />
            <PrivateRoute
              path="/nas-campaigns"
              exact
              component={NAScampaigns}
            />
            {/* <PrivateRoute path="/meta" exact component={Meta} /> */}

            {/* <PrivateRoute
              path="/job-matches/origins/profilmatcher-alerts"
              exact
              component={ProfilmatcherAlerts}
            />
            <PrivateRoute path="/job-matches" exact component={JobMatches} /> */}

            <PublicRoute path="/login" exact component={Login} />
            <PublicRoute
              path="/forgot-password"
              exact
              component={ForgotPassword}
            />

            <Route component={Page404} />
          </Switch>
        </Suspense>
      )}
    </>
  );
};

export default PrivateRoot;
